<template>
    <div class="form-datos px-4">
        <div class="d-flex  flex-wrap">
            <div class="d-flex flex-column col-50 no-flex" :class="{'red--text': errordni}">
                <v-text-field class="px-4" type="text" ref="dni" v-model="dni" label="Dni"></v-text-field>
                <p class="px-4 ">{{ menserrordni }}</p>
            </div> 
            <div class="d-flex flex-column col-50 no-flex" :class="{'red--text': errornombre}">
                <v-text-field class="px-4" type="text" ref="nombre" v-model="nombre" label="Nombre"></v-text-field>
                <p class="px-4 mb-0">{{ menserrornombre }}</p>
            </div> 
            <div class="d-flex flex-column col-50 no-flex" :class="{'red--text': errorapellidos}">
                <v-text-field class="px-4" type="text" ref="apellidos" v-model="apellidos" label="Apellidos"></v-text-field>
                <p class="px-4 mb-0">{{ menserrorapellidos }}</p> 
            </div> 
            <div class="d-flex flex-column col-50 no-flex" :class="{'red--text': erroremail}">
                <v-text-field class="px-4" type="text" ref="email" v-model="email" label="Email"></v-text-field>
                <p class="px-4 mb-0">{{ menserroremail }}</p> 
            </div> 
            <div class="d-flex flex-column col-50 no-flex" :class="{'red--text': errortelefono}">
                <v-text-field  class="px-4" type="text" ref="telefono" v-model="telefono" label="Teléfono"></v-text-field>
                <p class="px-4 mb-0">{{ menserrortelefono }}</p>
            </div>    
        </div>     
    <v-btn large dark fab flat absolute bottom right class="orange guardar anadircli" @click="anadirCliente">
    <!-- {{ $t('lang.comun.guardar') }}-->
        <v-icon>save</v-icon>
    </v-btn>
    </div>  
</template>
<script>
    import { ClienteApiService } from '@/api/ClienteApiService';
    import { Util } from '@/api/Util';

    const clienteApi = new ClienteApiService();
    const utilJs = new Util();

    export default {
        data() {
            return {
                cliente:{
                    status: 1,
                    tipo: 0,
                    alias: '',
                    moneda: 'EUR',
                    idioma: '17',
                    telefonoUno: '',
                    telefonoDos:'',
                    usuarioCreacion: 'system',
                    fechaAlta: new Date(),
                    usuarioModificacion: 'system',
                    fechaModificacion: new Date(),
                    bloqueado:'N',
                    nombre: '',
                    movil: '',
                    email: '',
                    enviado:'S',
                    mailVerificado: '',
                    uid: '8D803CC4-922B-484E-B075-0389F21DFD67',
                },

                nombre: '',
                dni: '',
                apellidos: '',
                email: '',
                telefono:'',
                errordni: false,
                menserrordni:'',
                erroremail:false,
                menserroremail: '',
                errornombre:false,
                menserrornombre: '',
                errorapellidos:false,
                menserrorapellidos: '',
                errortelefono:false,
                menserrortelefono: '',
                errord1:false,
                errord2:false,
            }
        },
        methods: {
            anadirCliente(){
                this.errordni = false;
                this.errord2 = false;
                this.errord1 = false;
                this.menserrordni = "";
                this.erroremail = false;
                this.menserroremail = "";
                this.errornombre = false;
                this.menserrornombre = "";
                this.errorapellidos = false;
                this.menserrorapellidos = "";
                this.errortelefono = false;
                this.menserrortelefono = "";


                let dniValid = utilJs.isValidDni(this.dni);
                // let dniEmptyValid = utilJs.isEmptyField(this.dni);
                let emailValid = utilJs.isValidEmail(this.email);
                let emailEmptyValid = utilJs.isEmptyField(this.email);
                let telefonoValid = utilJs.isValidTelefono(this.telefono);
                let telefonoEmptyValid = utilJs.isEmptyField(this.telefono);
                let nombreEmptyValid = utilJs.isEmptyField(this.nombre);
                let apellidosEmptyValid = utilJs.isEmptyField(this.apellidos);

                
                //Validación del dni
                    // if(dniEmptyValid){
                    //     this.errordni = true;
                    //     this.menserrordni = 'El DNI no es valido';
                    // }
                    // else{
                    
                        if(this.dni !== '' && !dniValid){
                            this.errordni = true;
                            this.menserrordni = 'El DNI no es valido';
                        }
                    // }

                //Validación del email
                    if(emailEmptyValid){
                        this.erroremail = true;
                        this.menserroremail = 'El Email no es valido';
                        this.errord2 = true;
                    }
                    else{
                        if(!emailValid)
                        {
                            this.erroremail = true;
                            this.menserroremail = 'El Email no es valido';
                            this.errord2 = true;
                        }
                    }

                //Validacion del telefono
                    if(telefonoEmptyValid){
                        this.errortelefono = true;
                        this.menserrortelefono = 'El Telefono no es valido';
                        this.errord2 = true;
                    }
                    else{
                        if(!telefonoValid){
                            this.errortelefono = true;
                            this.menserrortelefono = 'El Teléfono no es valido';
                            this.errord2 = true;
                        }
                    } 

                //Validacion del nombre
                    if(nombreEmptyValid){
                        this.errornombre = true;
                        this.menserrornombre = 'El Nombre no es valido';
                        this.errord1 = true;
                    }

                //Validacion de los apellidos
                    if(apellidosEmptyValid){
                        this.errorapellidos = true;
                        this.menserrorapellidos = 'El Apellido no es valido';
                        this.errord1 = true;
                    }    
    

                //Si no hay errores comprobamos si el dni y email estan registrados y si no insertara el cliente
                    if (!this.errord1 && !this.errord2 && !this.errordni)
                    {
                        this.cliente.nombre = this.nombre + " " + this.apellidos;
                        this.cliente.movil = this.telefono;
                        this.cliente.email = this.email;

                        clienteApi.anadirCliente(this.cliente)
                        .then(data => {
                            switch(data.error){
                                case "email":
                                    this.$root.$emit('mostrarAlerta', 'El Email ya existe', 'error')
                                break;
                                default:
                                    this.$root.$emit('mostrarAlerta', 'Cliente creado correctamente', 'info')
                                    this.$store.commit('setCliente', data.cliente);
                                    this.$router.push({name: 'cliente'})
                            }        
                        })
                        .catch(error => {
                            this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
                            console.log(error)
                        })
                    }
            }
        },
    }    
</script>
<style scoped>
  /* .contenedor{
        background-color: white;
        border-radius: .5em;
        margin: 0 auto;
        width: 600px;
    }

    .cerrar{
        color: #27629D;
        font-size: 13pt;
        border-bottom: 1px solid #27629D;
        margin-left: 10px;
        margin-right: 10px;
    }

    .cerrar img{
        margin-bottom: 8px;
    }

    .cerrar button{
        padding-right: 1.5%;
        font-weight: bold;
    }

    .cerrar span{
        width: 100%;
    }

    input{
        background-color: rgba(39,98,157,0.2);
        border-radius: 10px;
        padding-left: 6px;
    }

    .datoscli span{
        color:#27629D;
    }

    .anadircli{
        background-color: #27629D;
        border-radius: 20px;
        color: white;
        padding: 5px;
        padding-left: 10px;
        padding-right: 15px;
        margin-top: 18px;
        margin-left: 75%;
        margin-bottom: 15px;
    }

    .error span{
        color: #D92626;
    }

    p{
        margin-bottom: 0;
    }

    .error p{
        color: #D92626;
        font-size: 8pt;
        margin-bottom: 0;
        padding-top: 3px;
    }

    .tamano div{
        width: 50%;
    }

    .errord2 p,.errord1 p{
        height: 20px;
    }

    @media (max-width:1400px){
        .contenedor{
            width: 550px;
        }

         .anadircli{
            margin-left: 73%;
        }
    } 

    @media (max-width:900px){
        .contenedor{
            margin-left: 165px;
        }
    }

    @media (max-width:800px){
        .contenedor{
            margin-left: 100px;
        }
    }

    @media (max-width:700px){
        .contenedor{
            margin-left: 50px;
        }

         .anadircli{
            margin-left: 73%;
        }
    }

    @media (max-width:641px){
        .contenedor{
            width: 500px;
        }

        .anadircli{
            margin-left: 70%;
        }
    }

    @media (max-width:550px){
        .contenedor{
            width: 490px;
            margin-left: 5px;
        }

        .anadircli{
            margin-left: 69.9%;
        }
    }

     @media (max-width:490px){
        .contenedor{
            width: 370px;
            margin-left: 1.5vh;
        }

        .anadircli{
            margin-left: 60%;
        }
    }

    @media (max-width:400px) and (min-height:530px){
        .contenedor{
            width: 340px;
        }

        .anadircli{
            margin-left: 56.5%;
        }
    }

    @media (max-width:350px) and (max-height:570px){
        .contenedor{
            width: 305px;
        }

        .anadircli{
            margin-left: 51.5%;
        }
    } */
</style>